export const LIST_SUPPLIER = 'LIST_SUPPLIER';
export const LIST_PROVIDER_AUTORIZED = 'LIST_PROVIDER_AUTORIZED';